import GithubSlugger from 'github-slugger';

/**
 * Builds a table of contents from raw markdown.
 *
 * The ids are produced with the same slugger rehype-slug runs when rendering,
 * including its duplicate handling, so the links land on the right heading
 * even when a title repeats (the 2025 rules mention the Zombie Rule twice).
 *
 * Only h2/h3 are included — h1 is the page title and h4+ is too granular.
 */
export function buildToc(markdown) {
  const slugger = new GithubSlugger();
  const entries = [];
  let inFence = false;

  for (const line of markdown.split('\n')) {
    if (/^\s*```/.test(line)) {
      inFence = !inFence;
      continue;
    }
    if (inFence) continue;

    const match = line.match(/^(#{1,6})\s+(.*)$/);
    if (!match) continue;

    const depth = match[1].length;
    // Strip inline markdown so the label matches the rendered heading.
    const text = match[2]
      .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
      .replace(/[*_`~]/g, '')
      .replace(/\\(.)/g, '$1')
      .trim();

    // Every heading is slugged, even ones we skip, to stay in step with
    // rehype-slug's duplicate counter.
    const id = slugger.slug(text);
    if (depth === 2 || depth === 3) entries.push({ id, text, depth });
  }

  return entries;
}
